var map = {
	"./api.svg": 1147,
	"./caidan.svg": 7939,
	"./caozuorizhi.svg": 6148,
	"./dianshiji.svg": 4850,
	"./dingdan.svg": 5242,
	"./fangjianguanli.svg": 7729,
	"./fenlei.svg": 7146,
	"./guanliyuan.svg": 8202,
	"./home.svg": 7123,
	"./jifeiguanli.svg": 2750,
	"./jiudian.svg": 9063,
	"./jiudianshezhi.svg": 1514,
	"./kehu.svg": 6920,
	"./picture.svg": 8201,
	"./shezhi.svg": 1900,
	"./shuju.svg": 2562,
	"./sucai.svg": 1614,
	"./zhedie.svg": 6614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;